export default "__VITE_ASSET__CoecfI2H__"